import { useTheme } from '@mui/material';
import { SVGProps } from 'react';

export const ChargeIcon = (props: SVGProps<SVGSVGElement>) => {
  const theme = useTheme();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={36}
      height={36}
      fill="none"
      {...props}
    >
      <path
        fill={theme.palette.grey[100]}
        d="M0 18C0 8.059 8.059 0 18 0s18 8.059 18 18-8.059 18-18 18S0 27.941 0 18Z"
      />
      <path
        stroke={theme.palette.common.black}
        strokeLinecap="round"
        strokeWidth={1.25}
        d="M24.646 17.542v-3.438a.917.917 0 0 0-.917-.916H11.354a.917.917 0 0 0-.916.916v7.792c0 .506.41.916.916.916h6.188M23.042 19.604l3.143 3.144a.092.092 0 0 1 0 .13l-3.143 3.143M26.25 22.812h-5.958"
      />
      <circle
        cx={17.542}
        cy={18}
        r={1.604}
        stroke={theme.palette.common.black}
        strokeWidth={1.25}
      />
    </svg>
  );
};
